import { type JourneyType } from "@/scalars/journeyType"

export const formatJourneyType = (journeyType: JourneyType) =>
    journeyType === "CHANGE_OF_SUPPLIER" ? "CDF" : "MES"
